import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PushidService {

  private static PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
  private lastPushTime = 0;
  private lastRandChars: number[] = [];

  constructor() { }

  generatePushId(): string {
    let now = new Date().getTime();
    const duplicateTime = now === this.lastPushTime;
    this.lastPushTime = now;

    let timeStampChars = new Array(8);
    for (let i = 7; i >= 0; i--) {
      timeStampChars[i] = PushidService.PUSH_CHARS.charAt(now % 64);
      now = Math.floor(now / 64);
    }
    if (now !== 0) {
      throw new Error('We should have converted the entire timestamp.');
    }

    let id = timeStampChars.join('');

    if (!duplicateTime) {
      this.lastRandChars = [];
      for (let i = 0; i < 12; i++) {
        this.lastRandChars[i] = Math.floor(Math.random() * 64);
      }
    } else {
      // If the timestamp hasn’t changed since last push, increment the last random number
      let i = 11;
      for (; i >= 0 && this.lastRandChars[i] === 63; i--) {
        this.lastRandChars[i] = 0;
      }
      this.lastRandChars[i]++;
    }

    for (let i = 0; i < 12; i++) {
      id += PushidService.PUSH_CHARS.charAt(this.lastRandChars[i]);
    }

    if (id.length !== 20) {
      throw new Error('Length should be 20.');
    }

    return id;
  }
}
